import dayjs from "dayjs";
import { getSensorMeasureData } from "../../../../acquaount-dashboard-farm/src/saga/sagas/realtimeSensorMeasure.saga";
import { exportToExcel } from "../../../../acquaount-dashboard-farm/src/utils/csvUtils";

export const MAX_MONTHS = 4;
export const getMaxEndDate = (start) =>
  start ? dayjs(start).add(MAX_MONTHS, "month") : null;
export const getMinStartDate = (end) =>
  end ? dayjs(end).subtract(MAX_MONTHS, "month") : null;

export const downloadSensorData = async ({
  token,
  allDatastreams,
  startDate,
  endDate,
  fieldLabel,
  sensors,
  modelsData,
  onProgress,
  t,
}) => {
  if (!startDate || !endDate) {
    throw new Error("Date di inizio e fine sono obbligatorie");
  }

  const total = allDatastreams.length;
  const results = [];

  for (let i = 0; i < total; i++) {
    const { name: datastream_name, id_thing } = allDatastreams[i];

    try {
      const data = await getSensorMeasureData(
        token,
        id_thing,
        datastream_name,
        startDate.toISOString(),
        endDate.toISOString()
      );
      results.push({ datastream_name, data });
    } catch (sensorError) {
      console.error(`Errore per sensore ${datastream_name}:`, sensorError);

      results.push({ datastream_name, data: [] });
    }

    const progressValue = Math.round(((i + 1) / total) * 100);
    if (onProgress) onProgress(progressValue);
  }

  const hasData = results.some((r) => r.data && r.data.length > 0);
  if (!hasData) {
    throw new Error(
      t
        ? t("download_dialog.no_data_available")
        : "Nessun dato disponibile per il periodo selezionato"
    );
  }

  const responsesObj = {};
  results.forEach(({ datastream_name, data }) => {
    responsesObj[datastream_name] = data;
  });

  try {
    exportToExcel(responsesObj, allDatastreams, fieldLabel, sensors, modelsData);
    return responsesObj;
  } catch (exportError) {
    throw new Error(
      t
        ? t("download_dialog.export_error")
        : "Errore durante l'esportazione del file Excel"
    );
  }
};
